import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, input, OnInit, Optional, output, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MEDIA_TOKEN } from '../../../../../tockens';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { MediaService } from '@app/services/media.service';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';

@Component({
    selector: 'clever-traveller',
    templateUrl: './traveller.component.html',
    styleUrls: ['./traveller.component.scss'],
    standalone: false
})
export class TravellerComponent implements OnInit {
    context = input<string>('');
    mode = input<string>('');
    sendRes = output<any>();

    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);

    zielText = signal<string>('2');

    nbAdult = signal<number>(2);
    nbChildren = signal<number>(0);

    childrenList = signal<any[]>([]);

    destroyRef = inject(DestroyRef);

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected hotelService: HotelFiltersService,
        protected cruiseFiltersService: CruiseFiltersService,
        protected authGuard: AuthGuardService,

        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.initFilterSub();
    }

    initFilterSub() {
        switch (this.context()) {
            case 'cruise':
                this.cruiseFiltersService.getfilters$.pipe(
                    takeUntilDestroyed(this.destroyRef)
                ).subscribe((filter) => {
                    if (filter?.reisendeResult?.adults > 0) {
                        this.nbAdult.set(Number(filter?.reisendeResult.adults));
                        this.nbChildren.set(filter?.reisendeResult.children.length);
                        this.childrenList.set(filter?.reisendeResult.children);
                    }
                    this.zielText.set((this.nbAdult() + (this.nbAdult() === 1 ? ' Erwachsener' : ' Erwachsene')) + (this.nbChildren() > 0 ? ', ' + this.nbChildren() + (this.nbChildren() === 1 ? ' Kind' : ' Kinder') : ''));
                });

                break;

            default:
                this.hotelService.getfilters$.pipe(
                    takeUntilDestroyed(this.destroyRef)
                ).subscribe((filter) => {
                    if (filter?.reisendeResult?.adults > 0) {
                        this.nbAdult.set(Number(filter?.reisendeResult.adults));
                        this.nbChildren.set(filter?.reisendeResult.children.length);
                        this.childrenList.set(filter?.reisendeResult.children);
                    }
                    this.zielText.set((this.nbAdult() + (this.nbAdult() === 1 ? ' Erwachsener' : ' Erwachsene')) + (this.nbChildren() > 0 ? ', ' + this.nbChildren() + (this.nbChildren() === 1 ? ' Kind' : ' Kinder') : ''));
                });
                break;
        }
    }

    openModal() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    openModalMobile() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    closeModal() {
        this.showModal.set(false);
    }

    closeModalMobile() {
        this.showModal.set(false);
    }

    selected() {
        this.zielText.set((this.nbAdult() + (this.nbAdult() === 1 ? ' Erwachsener' : ' Erwachsene')) + (this.nbChildren() > 0 ? ', ' + this.nbChildren() + (this.nbChildren() === 1 ? ' Kind' : ' Kinder') : ''));

        this.sendRes.emit({
            adults: this.nbAdult(),
            children: this.childrenList()
        });
        this.closeModal();
    }

    addAdult(nbr) {
        this.nbAdult.set(nbr);
    }

    addChildren(nbr) {
        this.nbChildren.set(nbr);
        this.childrenList.set([]);
        if (nbr < 4) {
            for (let i = 0; i < nbr; i++) {
                this.childrenList().push({
                    name: 'Kind ' + (this.childrenList.length + 1),
                    age: null
                });
            }
        }
    }

    removeChildrentAge(ch) {
        if (ch.age > 0) {
            ch.age--;
        }
    }

    addChildrenAge(ch) {
        if (ch.age < 17) {
            ch.age++;
        }
    }

    checkAge(item) {
        if (item.age > 17) {
            item.age = 17;
        }

        if (item.age < 0) {
            item.age = 0;
        }
    }
}
